import React from "react";

const H1 = ({ children }) => (
  <h1 className="text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-3">{children}</h1>
);
const Lead = ({ children }) => (
  <p className="text-slate-500 mb-10 text-sm">{children}</p>
);
const H2 = ({ children }) => (
  <h2 className="text-xl font-semibold text-slate-900 mt-10 mb-3 tracking-tight">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-slate-700 leading-relaxed mb-3">{children}</p>
);
const Small = ({ children }) => (
  <p className="text-xs text-slate-500 leading-relaxed mt-8 p-4 bg-slate-50 rounded-xl border border-slate-100">{children}</p>
);

const Table = ({ children }) => (
  <div className="overflow-x-auto my-4">
    <table className="w-full text-sm border border-slate-200 rounded-xl overflow-hidden">{children}</table>
  </div>
);
const Th = ({ children }) => (
  <th className="text-left px-4 py-2 bg-slate-50 font-semibold text-slate-900 border-b border-slate-200">{children}</th>
);
const Td = ({ children }) => (
  <td className="px-4 py-2 border-b border-slate-100 text-slate-700 align-top">{children}</td>
);

export function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="text-xs uppercase tracking-wide text-emerald-700 font-semibold mb-3">Rechtliches</div>
      <H1>Datenschutzerklärung</H1>
      <Lead>Informationen zur Verarbeitung personenbezogener Daten nach Art. 13 DSGVO</Lead>

      <H2>1. Verantwortlicher</H2>
      <P>
        Verantwortlich für die Datenverarbeitung im Sinne von Art. 4 Nr. 7 DSGVO ist:
      </P>
      <P>
        Prof. Dr. med. Hagen Schmal<br />
        Maxim-Gorkij-Str. 9<br />
        79111 Freiburg<br />
        Deutschland<br />
        E-Mail: <a href="mailto:laclive@gmx.de" className="text-emerald-700 hover:underline">laclive@gmx.de</a>
      </P>

      <H2>2. Überblick der Verarbeitungen</H2>
      <P>
        Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung der Nutzer, aufgrund vertraglicher Erfüllung oder auf Basis unseres berechtigten Interesses.
      </P>
      <Table>
        <thead><tr><Th>Verarbeitung</Th><Th>Zweck</Th><Th>Rechtsgrundlage</Th></tr></thead>
        <tbody>
          <tr><Td>Aufruf der Website</Td><Td>Betrieb und Sicherheit</Td><Td>Art. 6 Abs. 1 lit. f DSGVO</Td></tr>
          <tr><Td>Nutzerkonto</Td><Td>Zugang zum bezahlten Bereich</Td><Td>Art. 6 Abs. 1 lit. b DSGVO</Td></tr>
          <tr><Td>Kaufabwicklung + Rechnung</Td><Td>Vertragserfüllung, gesetzliche Aufbewahrung</Td><Td>Art. 6 Abs. 1 lit. b und c DSGVO</Td></tr>
          <tr><Td>Kontaktformular</Td><Td>Bearbeitung der Anfrage</Td><Td>Art. 6 Abs. 1 lit. b bzw. f DSGVO</Td></tr>
        </tbody>
      </Table>

      <H2>3. Aufruf der Website und Server-Logs</H2>
      <P>
        Beim Aufruf der Website werden technisch notwendige Verbindungsdaten (IP-Adresse, Datum und Uhrzeit, Browser-Typ, aufgerufene URL) durch die Server unseres Hostingdienstleisters kurzzeitig verarbeitet. Diese Daten sind erforderlich für den Betrieb der Website, die Erkennung von Störungen und die IT-Sicherheit.
      </P>
      <P>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer stabilen und sicheren Website).<br />
        <strong>Speicherdauer:</strong> Server-Logfiles werden nach spätestens 30 Tagen gelöscht.
      </P>

      <H2>4. Nutzerkonto und Anmeldung</H2>
      <P>
        Für den Zugriff auf den kostenpflichtigen Ernährungsplan legen wir ein Nutzerkonto an. Verarbeitet werden:
      </P>
      <ul className="list-disc list-inside text-slate-700 leading-relaxed mb-3 space-y-1">
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Passwort (ausschließlich als sicherer Hash gespeichert, wir sehen es nie im Klartext)</li>
        <li>Zeitpunkt der Registrierung und Zahlung</li>
        <li>Zugangsstatus (freigeschaltet / nicht freigeschaltet)</li>
      </ul>
      <P>
        Für die Sitzungsverwaltung setzen wir einen technisch notwendigen HttpOnly-Cookie (JWT), der beim Abmelden gelöscht wird.
      </P>
      <P>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).<br />
        <strong>Speicherdauer:</strong> siehe Ziffer 8.
      </P>

      <H2>5. Kaufabwicklung, Zahlung und Rechnung</H2>
      <P>
        Zur Abwicklung eines Kaufs verarbeiten wir:
      </P>
      <ul className="list-disc list-inside text-slate-700 leading-relaxed mb-3 space-y-1">
        <li>Rechnungsadresse (Name, Straße, PLZ, Ort, Land)</li>
        <li>E-Mail-Adresse</li>
        <li>Bestell-/Rechnungsnummer, Rechnungsbetrag, Datum</li>
        <li>PayPal-Order-ID sowie den Zahlungsstatus</li>
      </ul>
      <P>
        Die Zahlung selbst erfolgt über den Zahlungsdienstleister PayPal (siehe Ziffer 7). Bank- oder Kartendaten erhalten und speichern wir nicht.
      </P>
      <P>
        Die generierte PDF-Rechnung erhalten Sie per E-Mail; eine Kopie wird ausschließlich zu Buchhaltungszwecken an unser Postfach übermittelt.
      </P>
      <P>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Aufbewahrungspflichten aus §§ 147 AO, 257 HGB).<br />
        <strong>Speicherdauer:</strong> siehe Ziffer 8.
      </P>

      <H2>6. Kontaktformular und E-Mail-Kontakt</H2>
      <P>
        Wenn Sie uns über das Kontaktformular oder per E-Mail schreiben, verarbeiten wir Name, E-Mail-Adresse und Ihre Nachricht zur Bearbeitung Ihres Anliegens. Anfragen werden bei uns gespeichert und zusätzlich per E-Mail an unser Postfach weitergeleitet.
      </P>
      <P>
        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO bei vertragsbezogenen Anfragen, sonst Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer effizienten Beantwortung).<br />
        <strong>Speicherdauer:</strong> siehe Ziffer 8.
      </P>

      <H2>7. Empfänger und Auftragsverarbeiter</H2>
      <P>
        Wir setzen sorgfältig ausgewählte Dienstleister ein, mit denen entsprechende Auftragsverarbeitungsverträge nach Art. 28 DSGVO abgeschlossen sind bzw. abgeschlossen werden:
      </P>
      <Table>
        <thead><tr><Th>Dienstleister</Th><Th>Zweck</Th><Th>Datenkategorien</Th></tr></thead>
        <tbody>
          <tr><Td>PayPal (Europe) S.à r.l. et Cie, S.C.A., Luxemburg</Td><Td>Zahlungsabwicklung</Td><Td>Name, E-Mail, Bestell-/Rechnungsnummer, Betrag; PayPal erhebt darüber hinaus eigene Daten - siehe <a href="https://www.paypal.com/de/legalhub/privacy-full" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">PayPal-Datenschutzerklärung</a>.</Td></tr>
          <tr><Td>Resend Inc., USA</Td><Td>Transaktionaler E-Mail-Versand (Kaufbestätigung, Rechnung, Kontaktweiterleitung)</Td><Td>Empfänger-E-Mail, Absender, Betreff, E-Mail-Inhalt inkl. PDF-Anhang. Datenübermittlung in ein Drittland gestützt auf EU-Standardvertragsklauseln (Art. 46 DSGVO). Details: <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">Resend-Datenschutz</a>.</Td></tr>
          <tr><Td>Hosting- und Datenbank-Provider (EU)</Td><Td>Bereitstellung der Website und Speicherung der Nutzerdaten</Td><Td>Server-Logs, Nutzerkonto-Daten, Bestellungen, Rechnungen</Td></tr>
        </tbody>
      </Table>
      <P>
        Eine Weitergabe an weitere Dritte findet nicht statt, es sei denn, wir sind hierzu gesetzlich verpflichtet (z. B. gegenüber Finanzbehörden).
      </P>

      <H2>8. Speicherdauer</H2>
      <P>
        Personenbezogene Daten werden nur so lange gespeichert, wie es für die genannten Zwecke erforderlich ist. Für zivilrechtliche Ansprüche greift die regelmäßige Verjährungsfrist von <strong>drei Jahren gemäß § 195 BGB</strong>, beginnend mit dem Ende des Jahres, in dem der Anspruch entstand. Wir speichern personenbezogene Daten daher grundsätzlich für diesen Zeitraum, sofern nicht längere gesetzliche Aufbewahrungspflichten bestehen.
      </P>
      <Table>
        <thead><tr><Th>Datenkategorie</Th><Th>Aufbewahrung</Th><Th>Rechtsgrundlage</Th></tr></thead>
        <tbody>
          <tr><Td>Nutzerkonto und Zugangsdaten</Td><Td>Dauer des Vertragsverhältnisses + 3 Jahre</Td><Td>§ 195 BGB (Verjährung)</Td></tr>
          <tr><Td>Kaufabwicklungsdaten (nicht steuerrelevant)</Td><Td>3 Jahre</Td><Td>§ 195 BGB</Td></tr>
          <tr><Td>Rechnungen und steuerrelevante Buchungsbelege</Td><Td>10 Jahre</Td><Td>§ 147 AO, § 257 HGB</Td></tr>
          <tr><Td>Kontaktanfragen</Td><Td>3 Jahre (kürzer bei erledigtem Anlass)</Td><Td>§ 195 BGB / Art. 6 Abs. 1 lit. f DSGVO</Td></tr>
          <tr><Td>Server-Logfiles</Td><Td>max. 30 Tage</Td><Td>Art. 6 Abs. 1 lit. f DSGVO</Td></tr>
        </tbody>
      </Table>
      <P>
        Nach Ablauf der Fristen werden die betreffenden Daten routinemäßig gelöscht, sofern keine weiteren Aufbewahrungsgründe bestehen.
      </P>

      <H2>9. Ihre Rechte als betroffene Person</H2>
      <P>Sie haben uns gegenüber folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</P>
      <ul className="list-disc list-inside text-slate-700 leading-relaxed mb-3 space-y-1">
        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
        <li>Widerruf einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
      </ul>
      <P>
        Zur Ausübung dieser Rechte genügt eine formlose Nachricht an <a href="mailto:laclive@gmx.de" className="text-emerald-700 hover:underline">laclive@gmx.de</a>.
      </P>

      <H2>10. Beschwerderecht bei einer Aufsichtsbehörde</H2>
      <P>
        Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs haben Sie das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes.
      </P>
      <P>
        Zuständige Behörde für Baden-Württemberg:<br />
        Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg<br />
        Königstraße 10a, 70173 Stuttgart<br />
        <a href="https://www.baden-wuerttemberg.datenschutz.de" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">www.baden-wuerttemberg.datenschutz.de</a>
      </P>

      <H2>11. Datensicherheit</H2>
      <P>
        Wir sichern die Übertragung Ihrer personenbezogenen Daten durchgängig mit einer TLS-Verschlüsselung (HTTPS). Passwörter werden nur als gesalzener bcrypt-Hash gespeichert. Der Zugriff auf die Datenbank ist auf autorisierte Personen beschränkt.
      </P>

      <H2>12. Änderung dieser Datenschutzerklärung</H2>
      <P>
        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt dann die aktualisierte Fassung.
      </P>

      <Small>
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}. Diese Datenschutzerklärung ist eine gut strukturierte Vorlage und sollte vor produktivem Einsatz durch eine Fachanwältin oder einen Fachanwalt für Datenschutzrecht überprüft werden.
      </Small>
    </div>
  );
}

export function Impressum() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="text-xs uppercase tracking-wide text-emerald-700 font-semibold mb-3">Rechtliches</div>
      <H1>Impressum</H1>
      <Lead>Angaben gemäß § 5 TMG</Lead>

      <H2>Anbieter</H2>
      <P>
        Prof. Dr. med. Hagen Schmal<br />
        Maxim-Gorkij-Str. 9<br />
        79111 Freiburg<br />
        Deutschland
      </P>

      <H2>Kontakt</H2>
      <P>
        E-Mail: <a href="mailto:laclive@gmx.de" className="text-emerald-700 hover:underline">laclive@gmx.de</a>
      </P>

      <H2>Umsatzsteuer-Identifikationsnummer</H2>
      <P>USt-IdNr. gemäß § 27 a UStG: <strong>DE298551357</strong></P>

      <H2>Berufsbezeichnung und berufsrechtliche Regelungen</H2>
      <P>
        Berufsbezeichnung: <strong>Arzt</strong> (verliehen in der Bundesrepublik Deutschland)
      </P>
      <P>
        Zuständige Kammer / Aufsichtsbehörde:<br />
        Landesärztekammer Baden-Württemberg<br />
        Bezirksärztekammer Südbaden<br />
        Sundgauallee 27, 79114 Freiburg im Breisgau<br />
        <a href="https://www.baek-sb.de" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">www.baek-sb.de</a>
      </P>
      <P>
        Es gelten folgende berufsrechtliche Regelungen:
      </P>
      <ul className="list-disc list-inside text-slate-700 leading-relaxed mb-3 space-y-1">
        <li>Berufsordnung der Landesärztekammer Baden-Württemberg</li>
        <li>Heilberufe-Kammergesetz Baden-Württemberg (HBKG)</li>
        <li>Musterberufsordnung der Bundesärztekammer (MBO-Ä)</li>
      </ul>
      <P>
        Die berufsrechtlichen Regelungen können auf der Website der zuständigen Kammer eingesehen werden.
      </P>

      <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
      <P>
        Prof. Dr. med. Hagen Schmal<br />
        Anschrift wie oben
      </P>

      <H2>Streitschlichtung</H2>
      <P>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
        {" "}<a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">https://ec.europa.eu/consumers/odr</a>.
      </P>
      <P>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </P>

      <H2>Haftung für Inhalte</H2>
      <P>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </P>
      <P>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </P>

      <H2>Medizinischer Hinweis</H2>
      <P>
        Die Inhalte auf LacLive dienen der allgemeinen Information und Aufklärung zu ernährungsmedizinischen Themen. Sie ersetzen keine individuelle ärztliche Beratung, Diagnose oder Therapie. Bei anhaltenden Beschwerden konsultieren Sie bitte eine Ärztin oder einen Arzt Ihres Vertrauens.
      </P>

      <Small>
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}. Die auf dieser Seite genannten Pflichtangaben werden regelmäßig überprüft. Für Fragen zum Impressum steht die oben angegebene E-Mail-Adresse zur Verfügung.
      </Small>
    </div>
  );
}

export function AGB() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="text-xs uppercase tracking-wide text-emerald-700 font-semibold mb-3">Rechtliches</div>
      <H1>Allgemeine Geschäftsbedingungen (AGB)</H1>
      <Lead>Vertragsbedingungen für die Nutzung von LacLive und den Erwerb des Ernährungsplans</Lead>

      <H2>§ 1 Geltungsbereich und Vertragspartner</H2>
      <P>
        Für alle Bestellungen und Verträge über diese Website gelten die nachfolgenden Allgemeinen Geschäftsbedingungen. Vertragspartner ist:
      </P>
      <P>
        Prof. Dr. med. Hagen Schmal, Maxim-Gorkij-Str. 9, 79111 Freiburg, USt-IdNr. DE298551357 (nachfolgend "Anbieter" oder "LacLive").
      </P>

      <H2>§ 2 Vertragsgegenstand</H2>
      <P>
        Vertragsgegenstand ist der Erwerb eines dauerhaften digitalen Zugangs zu einer medizinischen Beratungsleistung in Form eines strukturierten 12-Wochen-Ernährungsplans zur Wiederherstellung der Lactose-Toleranz einschließlich zugehöriger Rezepte und Informationsmaterialien ("Ernährungsplan").
      </P>
      <P>
        Der Ernährungsplan ersetzt keine individuelle ärztliche Diagnose oder Therapie. Bei bestehenden Vorerkrankungen oder anhaltenden Beschwerden ist vor Nutzung eine ärztliche Rücksprache empfohlen.
      </P>

      <H2>§ 3 Vertragsschluss</H2>
      <P>
        Die Darstellung des Ernährungsplans auf der Website stellt kein rechtlich bindendes Angebot dar, sondern eine Aufforderung zur Bestellung. Durch Anklicken der Zahlungsbestätigung (PayPal) gibt der Kunde ein verbindliches Angebot zum Kauf ab. Der Vertrag kommt mit Bestätigung der Zahlung durch den Zahlungsdienstleister und Freischaltung des Zugangs zustande.
      </P>

      <H2>§ 4 Preise und Zahlung</H2>
      <P>
        Der Preis für den Ernährungsplan beträgt <strong>19,99 EUR</strong> (inkl. 19 % gesetzlicher Umsatzsteuer) als Einmalzahlung. Der Betrag ist mit Vertragsschluss zur Zahlung fällig.
      </P>
      <P>
        Die Zahlung erfolgt ausschließlich über den Zahlungsdienstleister PayPal. Es gelten ergänzend die Nutzungs- und Datenschutzbedingungen von PayPal.
      </P>

      <H2>§ 5 Lieferung und Zugang</H2>
      <P>
        Nach erfolgreicher Zahlung erhält der Kunde unmittelbar dauerhaften Online-Zugang zum Ernährungsplan über sein Nutzerkonto. Es entstehen keine wiederkehrenden Kosten und kein Abonnement. Eine Rechnung wird zusätzlich per E-Mail als PDF-Anhang zugestellt.
      </P>

      <H2>§ 6 Widerrufsbelehrung</H2>
      <P className="italic">Verbraucher haben das folgende Widerrufsrecht:</P>

      <div className="p-5 rounded-xl bg-slate-50 border border-slate-100 mb-4">
        <p className="text-sm font-semibold text-slate-900 mb-2">Widerrufsrecht</p>
        <p className="text-sm text-slate-700 leading-relaxed">
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
        </p>
        <p className="text-sm text-slate-700 leading-relaxed mt-3">
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Prof. Dr. med. Hagen Schmal, Maxim-Gorkij-Str. 9, 79111 Freiburg, E-Mail: laclive@gmx.de) mittels einer eindeutigen Erklärung (z. B. per E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das nachstehende Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
        </p>
        <p className="text-sm text-slate-700 leading-relaxed mt-3">
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </p>

        <p className="text-sm font-semibold text-slate-900 mt-5 mb-2">Folgen des Widerrufs</p>
        <p className="text-sm text-slate-700 leading-relaxed">
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>

        <p className="text-sm font-semibold text-slate-900 mt-5 mb-2">Vorzeitiges Erlöschen des Widerrufsrechts</p>
        <p className="text-sm text-slate-700 leading-relaxed">
          Das Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen Datenträger befindlichen digitalen Inhalten, wenn wir mit der Ausführung des Vertrags begonnen haben, nachdem Sie
          {" "}<strong>1.</strong> ausdrücklich zugestimmt haben, dass wir mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnen, und
          {" "}<strong>2.</strong> Ihre Kenntnis davon bestätigt haben, dass Sie durch Ihre Zustimmung mit Beginn der Ausführung des Vertrags Ihr Widerrufsrecht verlieren.
        </p>
      </div>

      <H2>§ 7 Muster-Widerrufsformular</H2>
      <div className="p-5 rounded-xl bg-slate-50 border border-slate-100 mb-4 text-sm text-slate-700 leading-relaxed">
        <p>(Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>
        <ul className="list-none pl-0 mt-3 space-y-1">
          <li>An: Prof. Dr. med. Hagen Schmal, Maxim-Gorkij-Str. 9, 79111 Freiburg, E-Mail: laclive@gmx.de</li>
          <li>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf des LacLive Ernährungsplans</li>
          <li>Bestellt am (*) / Erhalten am (*)</li>
          <li>Name des/der Verbraucher(s)</li>
          <li>Anschrift des/der Verbraucher(s)</li>
          <li>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</li>
          <li>Datum</li>
        </ul>
        <p className="mt-3">(*) Unzutreffendes streichen.</p>
      </div>

      <H2>§ 8 Haftung</H2>
      <P>
        Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit. Für leichte Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer wesentlichen Vertragspflicht, deren Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht (Kardinalpflicht) und auf deren Einhaltung der Kunde regelmäßig vertrauen darf; die Haftung ist in diesem Fall auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
      </P>
      <P>
        Die Inhalte des Ernährungsplans wurden mit größter Sorgfalt erstellt, ersetzen jedoch keine individuelle ärztliche Beratung. Für Folgen einer eigenmächtigen Anwendung ohne vorherige medizinische Rücksprache übernimmt der Anbieter keine Haftung.
      </P>

      <H2>§ 9 Urheberrecht</H2>
      <P>
        Sämtliche Inhalte des Ernährungsplans (Texte, Grafiken, Rezepte, Bilder) sind urheberrechtlich geschützt. Eine Weitergabe, Vervielfältigung oder Veröffentlichung außerhalb der privaten Nutzung ist ohne vorherige schriftliche Zustimmung des Anbieters nicht gestattet.
      </P>

      <H2>§ 10 Datenschutz</H2>
      <P>
        Der Anbieter verarbeitet personenbezogene Daten des Kunden ausschließlich zur Abwicklung des Vertrags und im Rahmen der geltenden Datenschutzgesetze. Detaillierte Informationen finden sich in der Datenschutzerklärung.
      </P>

      <H2>§ 11 Anwendbares Recht, Gerichtsstand</H2>
      <P>
        Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Für Verbraucher gilt diese Rechtswahl nur, soweit hierdurch der durch zwingende Bestimmungen des Rechts des Staates des gewöhnlichen Aufenthalts des Verbrauchers gewährte Schutz nicht entzogen wird. Gerichtsstand ist, soweit gesetzlich zulässig, Freiburg im Breisgau.
      </P>

      <H2>§ 12 Streitbeilegung</H2>
      <P>
        Informationen zur Online-Streitbeilegung finden sich unter <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">ec.europa.eu/consumers/odr</a>. Der Anbieter ist nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </P>

      <H2>§ 13 Salvatorische Klausel</H2>
      <P>
        Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam oder undurchführbar sein oder werden, so wird dadurch die Wirksamkeit der übrigen Bestimmungen nicht berührt.
      </P>

      <Small>
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}. Diese AGB sind eine Vorlage und sollten vor produktivem Einsatz durch eine Fachanwältin oder einen Fachanwalt für IT-/Verbraucherrecht überprüft werden.
      </Small>
    </div>
  );
}
